/**
 * AI分析 · 常量
 */

/**
 * 允许访问"AI分析"功能的 group_id 白名单。
 *
 * 命中即可见入口（侧边栏菜单项 + 路由可达）；未命中则隐藏入口并禁用页面。
 *
 * 注：group_id 都是 UUID 字符串，严格匹配即可。
 * 维护时记得同步 src/pages/mainWrapper/SideComponent.js 里的
 * MINGYANG_AI_ALLOWED_GROUP_IDS 数组。
 */
export const ALLOWED_GROUP_IDS: ReadonlyArray<string> = [
  // 测试环境
  '6b1cf246-60f4-41da-8112-3a8c8e65374e',
  '4e270754-b583-4777-b371-1192c2a13ee0',
  'fe720c77-232e-48d0-8337-5521cb57bb20',
  // 生产环境
  '2e65fbc0-4566-4212-ba73-2350f0d548ee'
]

export function isMingyangAiAllowed(
  groupId: string | undefined | null
): boolean {
  if (!groupId) return false
  return ALLOWED_GROUP_IDS.includes(groupId)
}

/** 入口路由 */
export const MINGYANG_AI_ROUTE = '/mingyang-ai/analysis'

/** PhotoPickerPage 跳转的 from 标识，用于回调时区分调用方 */
export const PICKER_FROM_FLAG = 'mingyangAi'

/** 一次最多可选照片数 */
export const PICKER_MAX_COUNT = 30

/** 轮询间隔（毫秒） */
export const POLL_INTERVAL_MS = 2000
